<template>
	<div class="flex flex-direction">
		<div class="flex justify-between">
			<div class="flex flex-direction margin-lr-xl">
				<RealTimeAlarm></RealTimeAlarm>
				<videoBox/>
			</div>
			<div class="operaBoxRight">
				<EquipmentFailure :col="true"></EquipmentFailure>
				<RealTimeAlarmList :type="'singleSite'"></RealTimeAlarmList>
			</div>
		</div>
		<div class="margin-top-sm flex justify-between margin-left-xl">
			<div>
				<BigTitle :bigtitle="bigtitle2"></BigTitle>
				<BatteryCompartment></BatteryCompartment>
			</div>
			<div class="">
				<!-- <BigTitle :bigtitle="bigtitle3"></BigTitle> -->
				<MobileEnergy></MobileEnergy>
			</div>
		</div>
	</div>
</template>

<script>
import RealTimeAlarm from "@/components/common/realTimeAlarm";
import RealTimeAlarmList from "@/components/common/realTimeAlarmList";
// 设备故障
import EquipmentFailure from "@/views/singleSite/equipmentFailure.vue";
// 头部
import BigTitle from '../bigTitle';
// 电池仓
import BatteryCompartment from "@/views/singleSite/batteryCompartment.vue";
// 移动能源车
import MobileEnergy from "@/views/singleSite/mobileEnergy.vue";
//视频监控
import videoBox from "@/components/common/videoBox.vue";
import { indexRight } from '@/api/indexRight';
import '@/components/site/imouplayer.js'
export default {
  data () {
    return {
      options: {},
	  bigtitle:{
	    CHN:'告警分析',
	    ENG:'Alarm  Analysis'
	  },
	  bigtitle2:{
	    CHN:'充电仓',
	    ENG:'Battery'
	  },
	  bigtitle3:{
	    CHN:'移动能源车',
	    ENG:'Mobile energy'
	  },
		lecheng:false,
			yingshi:false,
			lechengFlag:true,
			other:false
    };
  },
  components: {
	BigTitle,
	RealTimeAlarm,
	RealTimeAlarmList,
	EquipmentFailure,
	BatteryCompartment,
	MobileEnergy,
	videoBox
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
	methods: {
	},
}
</script>
<style lang="scss" scoped>

</style>
